import { render, staticRenderFns } from "./view3.vue?vue&type=template&id=29e70c2b&scoped=true&"
import script from "./view3.vue?vue&type=script&lang=js&"
export * from "./view3.vue?vue&type=script&lang=js&"
import style0 from "./view3.vue?vue&type=style&index=0&id=29e70c2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e70c2b",
  null
  
)

export default component.exports